import React from "react";
import { List, Datagrid, TextField, ReferenceField } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";

const useImageFieldStyles = makeStyles((theme) => ({
  image: {
    width: 80,
  },
}));

const RunningResultsList = (props) => {
  const imageFieldClasses = useImageFieldStyles();

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="uid" />
        <TextField source="totalDistanceFT" />
        <TextField source="totalDistanceKM" />
        <TextField source="type" />
      </Datagrid>
    </List>
  );
};

export default RunningResultsList;
